import { render, staticRenderFns } from "./DeleteSessionReportModal.vue?vue&type=template&id=0edfed38&scoped=true&"
import script from "./DeleteSessionReportModal.vue?vue&type=script&lang=js&"
export * from "./DeleteSessionReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edfed38",
  null
  
)

export default component.exports